import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { AdapterTypeEnum } from '@zaoblako/shared/modules/traffic/enums/adapter.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link AdapterTypeEnum} enumeration values */
export const AdapterTypeEnumI18n: EnumI18nInterface<AdapterTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [AdapterTypeEnum['2D']]: '2D',
    [AdapterTypeEnum['3D']]: '3D',
  },
  [I18nLocalesEnum.EN_US]: {
    [AdapterTypeEnum['2D']]: '2D',
    [AdapterTypeEnum['3D']]: '3D',
  },
};
